import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ProductFrame } from "../components/ProductFrame";
import { Reveal } from "../components/Reveal";

const CATEGORIES = [
  "All",
  "Kasavu Cotton/Tissue Sarees",
  "Kasavu Set Mundu",
  "Mul Cotton Sarees",
  "Pure Cotton Sarees",
  "Silk Sarees",
];

export default function Collection() {
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  const filtered = filter === "All" ? products : products.filter((p) => p.category === filter);

  return (
    <div data-testid="collection-page" className="pt-32 min-h-screen">
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-14">
        <Reveal><span className="overline text-mj-golddeep">The Collection</span></Reveal>
        <Reveal delay={0.1}>
          <h1 className="font-serif-mj tracking-tight text-mj-text mt-6 text-5xl sm:text-6xl lg:text-7xl leading-[0.95]">
            Curated <span className="italic text-mj-red">weaves</span>
          </h1>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="font-sans-mj text-mj-muted leading-relaxed mt-8 max-w-xl">
            From luminous kasavu to festive silk, each piece chosen for its quality, comfort, and craftsmanship.
          </p>
        </Reveal>

        <div className="flex flex-wrap gap-x-6 gap-y-3 mt-12 border-t border-mj-border pt-8">
          {CATEGORIES.map((c) => (
            <button key={c} data-testid={`filter-${c.replace(/[^a-z]/gi, "-").toLowerCase()}`} onClick={() => setFilter(c)}
              className={`overline transition-colors ${filter === c ? "text-mj-red" : "text-mj-muted hover:text-mj-text"}`}>
              {c === "All" ? "All" : c.replace(" Sarees", "")}
            </button>
          ))}
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-32">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {filtered.map((p, i) => (
            <ProductFrame key={p.id} product={p} index={i} />
          ))}
        </div>
        {filtered.length === 0 && <p className="text-mj-muted mt-10">Loading collection…</p>}
      </section>
    </div>
  );
}
